import { BrowserRouter, Navigate, Outlet, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Journey from "@/pages/Journey";
import About from "@/pages/About";
import Connect from "@/pages/Connect";

const WebsiteLayout = () => (
  <>
    <SmoothScroll />
    <Nav />
    <main><Outlet /></main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/connect" element={<Connect />} />
          <Route element={<WebsiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/journey" element={<Journey />} />
            <Route path="/course" element={<Navigate to="/journey" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
